import { Component, OnInit, Injector } from '@angular/core';
import { SecondPageEditBase } from 'vnpost-shared';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { GroupServiceProductService } from '../../services/group-service-product.service';

@Component({
  selector: 'app-create-group-service-product',
  templateUrl: './create-group-service-product.component.html',
  styleUrls: ['./create-group-service-product.component.css']
})
export class CreateGroupServiceProductComponent extends SecondPageEditBase
implements OnInit
{
listStatus: { label: string; value: number }[] = [
  { label: 'Đang áp dụng', value: 1 },
  { label: 'Ngừng áp dụng', value: 0 },
];
listSale: { label: string; value: number }[]=[
  { label: 'Dịch vụ bưu chính', value: 1 },
  { label: 'Tài chính bưu chính', value: 2 },
  { label: 'Phân phối truyền thông', value: 3 },
]

constructor(
  protected _service: GroupServiceProductService,
  protected _injector: Injector,
) {
  super(_service, _injector);
  this.formGroup = new UntypedFormGroup({
    businessSectorCode: new UntypedFormControl('', [Validators.required]),
    serviceProductGroupCode: new UntypedFormControl('', [Validators.required]),
    serviceProductGroupName: new UntypedFormControl('', [Validators.required]),
    status: new UntypedFormControl(''),
  });
}

ngOnInit() {
}

onShowPopup() {
  this.validationSummary.resetErrorMessages();
  this.resetForm();
  this.onReset();

  this.itemDetail.id = 0;
  this.itemDetail.status = 1;
  this.itemDetail.businessSectorCode = 1;
}

async save() {
  this.submitting = true;

  if (this.formGroup.invalid) {
    this.submitting = false;
    this.validationSummary.showValidationSummary();
    return;
  }
  
  this.onInsert();
}

onInsert() {
  this._service.create(this.itemDetail).then(
    (response) => {
      this.closePopupMethod(true);
      this._notifierService.showInsertDataSuccess();
      this.onAfterSave();
      this.submitting = false;
    },
    (error) => {
      this._notifierService.showInsertDataFailed();
      this.submitting = false;
    }
  );
}
}
